/*Flexi Box Bundle Script Code*/

document.addEventListener('DOMContentLoaded', function () {
  let shouldPreserveScrollOnAutoTab = false;

  // Enable checkboxes after page load
  document.querySelectorAll("input[type='checkbox']").forEach(function(checkbox) {
    checkbox.disabled = false;
  });

  // Scroll to top on page load
  window.addEventListener("beforeunload", function () {
    window.scrollTo(0, 0);
  });

  // Show/Hide header tabs
  document.querySelectorAll('.tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      // Remove 'active-tab-content' from all tab contents
      document.querySelectorAll('.tab-content').forEach(function(content) {
        content.classList.remove('active-tab-content');
      });
      // Add 'active-tab-content' to the tab content with matching data-id
      var dataId = tab.getAttribute('data-id');
      var targetContent = document.querySelector(".tab-content[data-id='" + dataId + "']");
      if (targetContent) {
        targetContent.classList.add('active-tab-content');
      }
      // Remove 'active-tab' from all tabs
      document.querySelectorAll('.tab').forEach(function(t) {
        t.classList.remove('active-tab');
      });
      // Add 'active-tab' to all tabs within the same parent as the clicked tab
      tab.parentElement.querySelectorAll('.tab').forEach(function(t) {
        t.classList.add('active-tab');
      });
      // Update all bubble counters when switching tabs
      updateAllBubbleCounters();
      // Clear the search bar and trigger keyup event
      var searchbar = document.getElementById('searchbar');
      if (searchbar) {
        searchbar.value = '';
        var event = new KeyboardEvent('keyup', { bubbles: true });
        searchbar.dispatchEvent(event);
      }

      if (!shouldPreserveScrollOnAutoTab) {
        // Keep manual tab clicks behavior unchanged
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      shouldPreserveScrollOnAutoTab = false;
    });
  });

  // Sticky header on-scroll
let lastScrollTop = 0;

window.addEventListener('scroll', function () {
  const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, 0);
  const height = window.innerHeight;

  document.querySelectorAll('.sticky-header').forEach(header => {
    
    // Show header after scrolling past viewport height
    if (scrollTop > height) {
      header.classList.add('show');
    } else {
      header.classList.remove('show');
    }

    // Detect scroll direction safely
    if (scrollTop > lastScrollTop + 2) { 
      header.classList.add('hide');   // scrolling down
    } else if (scrollTop < lastScrollTop - 2) {
      header.classList.remove('hide'); // scrolling up
    }
  });

  lastScrollTop = scrollTop;
}, { passive: true });


  // Bubble counter update function to updates all bubble counters based on current state
  function updateAllBubbleCounters() {
    document.querySelectorAll('.bubble-counter').forEach(counter => {
      const tabId = counter.id.match(/checkbox_count_tab_(\d+)/)[1];
      const checkedCount = document.querySelectorAll(`[data-id="tab${tabId}"] input:checked`).length;
      const selectionLimit = document.querySelector(`.tab-content[data-id="tab${tabId}"]`)?.getAttribute('data-product-limit');
      const isLimitReached = (checkedCount === parseInt(selectionLimit));
      const parentTab = counter.closest('.tab');
      const isActive = parentTab?.classList.contains('active-tab');
      
      // Reset classes
      counter.classList.remove('limit-reached', 'active-limit-reached');   
      if (isLimitReached) {
        counter.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="11" height="9" viewBox="0 0 11 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66802 1.37429L4.48642 7.85309L0.416016 4.46069L1.18402 3.53909L4.31362 6.14669L8.73201 0.625488L9.66802 1.37429Z" fill="#fff" stroke="#fff" stroke-width="0.5"/></svg>`;     
        if (isActive) {
          counter.classList.add('active-limit-reached');
        } else {
          counter.classList.add('limit-reached');
        }
      } else if (checkedCount > 0) {
        counter.textContent = checkedCount;
      } else {
        counter.textContent = '';
      }
    });
  }

  // Passing line-items on clicking submit button
  // document.getElementById("submit-btn").addEventListener("click", function (e) {
  //   e.preventDefault(); // Prevent default form submission
  //   const submitButton = e.target;
  //   submitButton.classList.add("loading");
  //   const isBuyNow = submitButton.textContent.toLowerCase().trim() === "buy now";
    
  //   if (isBuyNow && !submitButton.classList.contains("zecpe-btn")) {
  //     // Custom code for Zecpe buy now checkout function
  //     submitButton.classList.add("zecpe-btn");
  //     submitButton.classList.add("zecpe-btn-clicked");
  //     // * Stopping the event propagation
  //     // e.preventDefault();
  //     e.stopPropagation();
  //     e.stopImmediatePropagation();
  //     // Custom code for Zecpe buy now checkout function ends here
  //   }

  //   const flexiBoxForm = document.getElementById("flexi-box-form");
  //   const checkedInputs = flexiBoxForm.querySelectorAll("input:checked");
  //   const variantId = parseInt(flexiBoxForm.dataset.variantId);
  //   const parent_sku = flexiBoxForm.dataset.sku;
  //   const parent_price = parseFloat((flexiBoxForm.dataset.price)/100);
  
  //   // Get product data
  //   let itemCounter = 1;
  //   let bundleCounter = 1;
  //   let total_regular_price = 0;
  //   let priceMarkUp = 0;
    
  //   // Prepare properties objects with separate collections
  //   const itemProperties = {};
  //   const bundleProperties = {};
    
  //   // Add parent SKU property first to bundle properties
  //   bundleProperties['_bundle_product1'] = `${parent_sku}/0/1`;
  //   bundleCounter++;
    
  //   // Calculate total regular price
  //   checkedInputs.forEach(function(input) {
  //     total_regular_price += parseInt(input.dataset.price);
  //   });
    
  //   // Process checked inputs
  //   checkedInputs.forEach(function(input, index) {
  //     if (input.value === "No") {
  //       input.disabled = true;
  //     } else {
  //       // Add to ITEM properties
  //       itemProperties[`_ITEM${itemCounter}`] = input.value;
        
  //       // Calculate bundle price
  //       let proportional_price = parseFloat(((parseInt(input.dataset.price) / total_regular_price) * parent_price).toFixed(2));
  //       priceMarkUp += proportional_price;
  //       let lastDigit = parent_price - parseFloat(priceMarkUp.toFixed(2));
  //       let isLast = index === checkedInputs.length - 1;
        
  //       // Add to bundle properties
  //       if (isLast) {
  //         bundleProperties[`_bundle_product${bundleCounter}`] = `${input.dataset.sku}/${(proportional_price + lastDigit)}/1`;
  //       } else {
  //         bundleProperties[`_bundle_product${bundleCounter}`] = `${input.dataset.sku}/${proportional_price}/1`;
  //       }
  //       itemCounter++;
  //       bundleCounter++;
  //     }
  //   });
    
  //   // Combine properties in desired order
  //   let properties = {
  //     ...itemProperties,
  //     ...bundleProperties
  //   };
    
  //   // Prepare the cart add request
  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Accept': 'application/json'
  //     },
  //     body: JSON.stringify({
  //       items: [{
  //         id: variantId,
  //         quantity: 1,
  //         properties: properties
  //       }],
  //       sections: ["mini-cart", "cart-icon-bubble"]
  //     })
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     // console.log('Added to cart:', data);
  //     if (isBuyNow) {
  //       window.ZecpeCheckVariant(submitButton); // Zecpe buy now checkout function
  //     } 
  //     else {
  //       // Update mini-cart and cart icon
  //       if (data.sections) {
  //         document.getElementById('mini-cart').innerHTML = data.sections['mini-cart'];
  //         document.getElementById('cart-icon-bubble').innerHTML = data.sections["cart-icon-bubble"];
  //       }
  //       document.querySelector(".cart-drawer-container")?.firstElementChild?.click(); // Open cart drawer
  //       submitButton.classList.remove("loading"); // Remove button loading
  //     } 
  //   })
  //   .catch(error => {
  //     console.error('Error:', error);
  //   });
  // });

  // Get the total number of tabs
  const totalTabs = document.querySelectorAll(".tab").length;
  // Get all checkbox inputs
  let checkboxes = document.querySelectorAll("input[type='checkbox']");
  
  // Store the initial input values of checkboxes in an object on page load
  const initProdValues = {};
  checkboxes.forEach(function(checkbox) {
    initProdValues[checkbox.id] = checkbox.value.trim();
  });
  // console.log(initProdValues);

  // Checkbox click functionality code
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener("click", function () {
      const initProductValue = initProdValues[this.id];
      let currProductValue = this.value.trim();
      // console.log("Initial:", initProductValue, "Current:", currProductValue);
  
      // Initial and Current checkbox values, reload if does not match
      if (currProductValue !== initProductValue) {
        location.reload();
      }
  
      let currProduct = this.getAttribute("data-id");
      let currProductDataId = this.getAttribute("data-id-products");
      let currTabId = Number(currProductDataId.split("_")[1]);
      let selectionLimit = document.querySelector(`.tab-content[data-id="tab${currTabId}"]`).getAttribute("data-product-limit");
  
      // Hide elements
      let productInfo = this.closest(".collection-item");
      if (productInfo) {
        productInfo.querySelectorAll(".added_to_cart, .product_counter").forEach(function(el) {
          el.classList.add("_hidden");
        });
         productInfo.querySelectorAll(".one-fourth-column").forEach(function(el) {
            el.classList.remove("is-active");
          });
      }
      if (this.checked) {
        if (productInfo) {
          productInfo.querySelectorAll(".added_to_cart, .product_counter").forEach(function(el) {
            el.classList.remove("_hidden");
          });
           productInfo.querySelectorAll(".one-fourth-column").forEach(function(el) {
            el.classList.add("is-active");
          });
        }
        let productTitle = this.value.split("/")[0];
        document.querySelectorAll(".message-bar").forEach(function(bar) {
          let span = bar.querySelector("p span");
          if (span) span.textContent = productTitle;
          requestAnimationFrame(function() {
            var cartEl = document.getElementById("sticky-cart-bar");
            var cartH = cartEl ? cartEl.offsetHeight : 70;
            bar.style.bottom = (cartH + 10) + "px";
            bar.classList.remove("is-hidden");
            setTimeout(function () {
              bar.classList.add("is-hidden");
              if (span) span.textContent = "";
            }, 2500);
          });
        });
      }
      // Count checked checkboxes in current tab
      let n = document.querySelectorAll(`[data-id=tab${currTabId}] input:checked`).length;
      // console.log(currTabId, selectionLimit);
      // console.log(n);
  
      // Enable/disable checkboxes based on selection limit
      let notChecked = document.querySelectorAll(`[data-id=tab${currTabId}] input:not(:checked)`);
      let action = true;
      if (n == selectionLimit) {
        notChecked.forEach(function(input) {
          input.disabled = true;
        });
      } else {
        action = false;
        notChecked.forEach(function(input) {
          input.disabled = false;
        });
      }
      if (n > selectionLimit) {
        location.reload();
      }
      // Update bubble counters when checkbox selection changes
      updateAllBubbleCounters();
  
      // Go to next tab after adding mandatory items
      if (action === true) {
        let nextTab = `tab${currTabId + 1}`;
        let nextTabElem = document.querySelector(`.tab[data-id='${nextTab}']`);
        if (nextTabElem) {
          shouldPreserveScrollOnAutoTab = true;
          nextTabElem.click();
        }
  
        // Clear search
        let searchbar = document.getElementById("searchbar");
        if (searchbar) {
          searchbar.value = "";
          let event = new KeyboardEvent('keyup', { bubbles: true });
          searchbar.dispatchEvent(event);
        }
  
      }
  
      // Update sticky cart
      updateStickyCart();
    });
  });

  // === STICKY CART ===
  const cartBar = document.getElementById('sticky-cart-bar');
  const totalRequired = cartBar ? parseInt(cartBar.dataset.totalRequired) : 0;
  const dealPrice = cartBar ? parseInt(cartBar.dataset.dealPrice) : 0;
  const breakdownText = cartBar && cartBar.dataset.breakdownText
    ? cartBar.dataset.breakdownText
    : ('Add Any ' + totalRequired + ' Perfumes');
  const selectedItems = {};
  let wasComplete = false;

  // Editable copy from the section settings (placeholders: {count} {total} {remaining})
  const copyDefaults = {
    titleInitial: 'Unlock Free Gifts',
    subInitial: 'Add Any {total} Perfumes',
    titleProgress: '{count}/{total} Added',
    subPartial: '{remaining} More To Unlock Free Gifts',
    subComplete: "You've unlocked Free Gifts",
    freeTag: 'Free Gift',
    freeMsg: 'Yay! Your free gifts have been added'
  };
  let copy = copyDefaults;
  try {
    const parsed = cartBar && cartBar.dataset.copy ? JSON.parse(cartBar.dataset.copy) : {};
    copy = Object.assign({}, copyDefaults);
    Object.keys(parsed).forEach(function(key) {
      if (parsed[key]) copy[key] = parsed[key];
    });
  } catch (e) {
    copy = copyDefaults;
  }
  function fmt(template, count) {
    return String(template)
      .replace(/\{count\}/g, count)
      .replace(/\{total\}/g, totalRequired)
      .replace(/\{remaining\}/g, Math.max(totalRequired - count, 0));
  }

  // Free gifts (image + name) configured in the section settings, rendered as JSON
  // Original value of each free gift, shown struck through next to FREE (hardcoded on purpose)
  const FREE_GIFT_CUT_PRICE = 199;

  let freeGifts = [];
  try {
    freeGifts = cartBar && cartBar.dataset.freeGifts ? JSON.parse(cartBar.dataset.freeGifts) : [];
  } catch (e) {
    freeGifts = [];
  }

  function updateStickyCart() {
    const items = Object.values(selectedItems);
    const count = items.length;
    const mrpTotal = items.reduce(function(sum, item) { return sum + item.price; }, 0);
    const savings = mrpTotal - dealPrice;
    const allSelected = (count === totalRequired && totalRequired > 0);

    // Slots
    const slotsEl = document.getElementById('sc-slots');
    if (slotsEl) {
      if (count === 0) {
        slotsEl.innerHTML = '<div class="sc-slot-initial"><span>+</span></div>';
      } else {
        let html = '';
        items.forEach(function(item) {
          html += '<div class="sc-slot sc-slot--filled"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></div>';
        });
        for (let i = count; i < totalRequired; i++) {
          html += '<div class="sc-slot sc-slot--empty"><span>+</span></div>';
        }
        slotsEl.innerHTML = html;
      }
    }

    // Refs
    const titleEl = document.getElementById('sc-title');
    const subEl = document.getElementById('sc-sub');
    const addedText = document.getElementById('sc-added-text');
    const expandBtn = document.getElementById('sc-expand-btn');
    const scBottom = document.getElementById('sc-bottom');
    const valueWrap = document.getElementById('sc-value-wrap');
    const savingsWrap = document.getElementById('sc-savings-wrap');
    const valueEl = document.getElementById('sc-value');
    const savingsEl = document.getElementById('sc-savings');
    const dealPriceText = document.getElementById('sc-deal-price-text');
    const mrpStrike = document.getElementById('sc-mrp-strike');
    const submitBtn = document.getElementById('submit-btn');
    const drawerPayBtn = document.getElementById('sc-drawer-pay');

    if (count === 0) {
      // Initial state — single row
      if (titleEl) titleEl.textContent = fmt(copy.titleInitial, count);
      if (subEl) subEl.textContent = fmt(copy.subInitial, count);
      if (addedText) { addedText.textContent = fmt(copy.titleProgress, 0); addedText.style.display = ''; }
      if (expandBtn) expandBtn.style.display = 'none';
      if (scBottom) scBottom.style.display = 'none';
    } else if (!allSelected) {
      // Partial state — 2 rows, Item Value, grey PAY NOW
      if (titleEl) titleEl.textContent = fmt(copy.titleProgress, count);
      if (subEl) subEl.textContent = fmt(copy.subPartial, count);
      if (addedText) addedText.style.display = 'none';
      if (expandBtn) expandBtn.style.display = 'flex';
      if (scBottom) scBottom.style.display = 'flex';
      if (valueWrap) valueWrap.style.display = '';
      if (valueEl) valueEl.textContent = '₹' + mrpTotal.toLocaleString('en-IN') + '.00';
      if (savingsWrap) savingsWrap.style.display = 'none';
    } else {
      // Complete state — items sell at MRP, so no savings / strike price; just the value + yellow PAY NOW
      if (titleEl) titleEl.textContent = fmt(copy.titleProgress, count);
      if (subEl) subEl.textContent = fmt(copy.subComplete, count);
      if (addedText) addedText.style.display = 'none';
      if (expandBtn) expandBtn.style.display = 'flex';
      if (scBottom) scBottom.style.display = 'flex';
      if (valueWrap) valueWrap.style.display = '';
      if (valueEl) valueEl.textContent = '₹' + mrpTotal.toLocaleString('en-IN') + '.00';
      if (savingsWrap) savingsWrap.style.display = 'none';
    }

    // PAY NOW state
    if (submitBtn) {
      submitBtn.disabled = !allSelected;
      submitBtn.classList.toggle('flexi-pay-btn--active', allSelected);
    }
    if (drawerPayBtn) {
      drawerPayBtn.disabled = !allSelected;
      drawerPayBtn.classList.toggle('flexi-pay-btn--active', allSelected);
    }

    // Update drawer
    updateDrawer(items, count, mrpTotal, savings, allSelected);

    // Box just became full: open the drawer so the customer sees the free gifts being added
    if (allSelected && !wasComplete) {
      setTimeout(function() {
        const drawerEl = document.getElementById('sc-drawer');
        if (drawerEl && !drawerEl.classList.contains('sc-drawer--open')) openDrawer();
      }, 400);
    }
    wasComplete = allSelected;
  }

  function updateDrawer(items, count, mrpTotal, savings, allSelected) {
    // Grid cards with inline captions
    const gridEl = document.getElementById('sc-drawer-grid');
    if (gridEl) {
      let html = '';
      items.forEach(function(item) {
        html += '<div class="sc-grid-item">'
          + '<div class="sc-grid-card sc-grid-card--filled">'
          + '<button type="button" class="sc-grid-remove" data-checkbox-id="' + item.checkboxId + '" aria-label="Remove">\xD7</button>'
          + '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">'
          + '</div>'
          + '<div class="sc-grid-caption">'
          + '<span class="sc-caption-title">' + item.title + '</span>'
          + '<span class="sc-caption-price">₹' + item.price.toLocaleString('en-IN') + '</span>'
          + '</div>'
          + '</div>';
      });
      for (var i = count; i < totalRequired; i++) {
        html += '<div class="sc-grid-item"><div class="sc-grid-card sc-grid-card--empty"><span>+</span></div></div>';
      }
      // Free gifts — visual only (added by GoKwik). Grey until the box is full, then highlighted.
      // No remove button: gifts can't be deleted.
      freeGifts.forEach(function(gift) {
        html += '<div class="sc-grid-item sc-grid-item--free' + (allSelected ? ' is-unlocked' : ' is-locked') + '">'
          + '<div class="sc-grid-card sc-grid-card--free">'
          + (gift.image ? '<img src="' + gift.image + '" alt="' + gift.name + '" loading="lazy">' : '')
          + '<span class="sc-free-tag">' + copy.freeTag + '</span>'
          + '</div>'
          + '<div class="sc-grid-caption">'
          + '<span class="sc-caption-title">' + gift.name + '</span>'
          + '<span class="sc-caption-price sc-caption-price--free"><span class="sc-free-word">FREE</span><s>₹' + FREE_GIFT_CUT_PRICE + '</s></span>'
          + '</div>'
          + '</div>';
      });
      gridEl.innerHTML = html;
      gridEl.querySelectorAll('.sc-grid-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var cb = document.getElementById(this.dataset.checkboxId);
          if (cb && cb.checked) cb.click();
        });
      });
      gridEl.querySelectorAll('.sc-grid-card--empty').forEach(function(card) {
        card.addEventListener('click', function(e) {
          e.stopPropagation();
          closeDrawer();
        });
      });
    }

    // Count
    const drawerCount = document.getElementById('sc-drawer-count');
    if (drawerCount) drawerCount.textContent = count;

    // Bill
    const billCount = document.getElementById('sc-bill-count');
    const billSubtotal = document.getElementById('sc-bill-subtotal');
    const billSaveRow = document.getElementById('sc-bill-save');
    const billSavings = document.getElementById('sc-bill-savings');
    const billTotal = document.getElementById('sc-bill-total');

    if (billCount) billCount.textContent = count;
    if (billSubtotal) billSubtotal.textContent = '₹' + mrpTotal.toLocaleString('en-IN');
    // "Free gifts added" message, only when the box is full
    const freeMsgEl = document.getElementById('sc-free-msg');
    if (freeMsgEl) {
      freeMsgEl.textContent = copy.freeMsg;
      freeMsgEl.style.display = allSelected ? '' : 'none';
    }

    // No savings on this deal — items sell at MRP and the gifts are free
    if (billSaveRow) billSaveRow.style.display = 'none';
    if (billTotal) billTotal.textContent = '₹' + mrpTotal.toLocaleString('en-IN');

    // Footer: always Item Value
    const footerLabel = document.getElementById('sc-footer-label');
    const footerValue = document.getElementById('sc-footer-value');
    if (footerLabel) footerLabel.textContent = 'Item Value:';
    if (footerValue) footerValue.textContent = '₹' + mrpTotal.toLocaleString('en-IN');

    // Cut price = Item Value + the free gifts' value, shown once the box is full
    const footerCut = document.getElementById('sc-footer-cut');
    if (footerCut) {
      if (allSelected && freeGifts.length) {
        footerCut.textContent = '₹' + (mrpTotal + FREE_GIFT_CUT_PRICE * freeGifts.length).toLocaleString('en-IN');
        footerCut.hidden = false;
      } else {
        footerCut.hidden = true;
      }
    }
  }

  // Hook into checkbox changes to track selected items
  document.querySelectorAll("#flexi-box-form input[type=checkbox]").forEach(function(cb) {
    cb.addEventListener('change', function() {
      if (this.checked) {
        selectedItems[this.id] = {
          checkboxId: this.id,
          image: this.dataset.image || '',
          title: this.dataset.title || this.value.split('/')[0],
          price: parseInt(this.dataset.price) || 0
        };
      } else {
        delete selectedItems[this.id];
      }
      updateStickyCart();
    });
  });

  // Expand / collapse drawer
  const expandBtn = document.getElementById('sc-expand-btn');
  const drawer = document.getElementById('sc-drawer');
  const drawerClose = document.getElementById('sc-drawer-close');

  var _drawerScrollY = 0;
  function openDrawer() {
    _drawerScrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _drawerScrollY + 'px';
    document.body.style.width = '100%';
    document.body.classList.add('sc-drawer-open');
    drawer.classList.add('sc-drawer--open');
    if (expandBtn) expandBtn.classList.add('sc-expand-btn--open');
    if (cartBar) cartBar.classList.add('sc-drawer-active');
  }
  function closeDrawer() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, _drawerScrollY);
    document.body.classList.remove('sc-drawer-open');
    drawer.classList.remove('sc-drawer--open');
    if (expandBtn) expandBtn.classList.remove('sc-expand-btn--open');
    if (cartBar) cartBar.classList.remove('sc-drawer-active');
  }

  const scTop = document.querySelector('.sc-top');
  if (scTop && drawer) {
    scTop.addEventListener('click', function(e) {
      e.stopPropagation();
      // Only open drawer when items are selected (expand btn visible)
      if (!expandBtn || expandBtn.style.display === 'none') return;
      drawer.classList.contains('sc-drawer--open') ? closeDrawer() : openDrawer();
    });
  }
  if (drawerClose && drawer) {
    drawerClose.addEventListener('click', closeDrawer);
  }

  // Close drawer on overlay click
  document.addEventListener('click', function(e) {
    if (!document.body.classList.contains('sc-drawer-open')) return;
    var cart = document.getElementById('sticky-cart-bar');
    if (cart && !cart.contains(e.target)) closeDrawer();
  });

  // Drawer PAY NOW → trigger main submit
  const drawerPayBtn = document.getElementById('sc-drawer-pay');
  if (drawerPayBtn) {
    drawerPayBtn.addEventListener('click', function() {
      const submitBtn = document.getElementById('submit-btn');
      if (submitBtn && !submitBtn.disabled) submitBtn.click();
    });
  }

  // Hide sticky cart when header search/details opens
  var headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper && cartBar) {
    var headerObserver = new MutationObserver(function() {
      var hasOpenDetails = headerWrapper.querySelector('details[open]');
      if (hasOpenDetails) {
        cartBar.style.opacity = '0';
        cartBar.style.pointerEvents = 'none';
      } else {
        cartBar.style.opacity = '';
        cartBar.style.pointerEvents = '';
      }
    });
    headerObserver.observe(headerWrapper, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }

  // Initial render
  updateStickyCart();

  // Disable right-click context menu
  document.addEventListener("contextmenu", function(e) {
    e.preventDefault();
  });
  // Disable F12 key (Inspect Element)
  document.addEventListener("keydown", function(e) {
    if (e.key === "F12" || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
  });

  // Custom search bar functionality (no-op on this page — no search bar markup)
  var searchbarEl = document.getElementById("searchbar");
  if (searchbarEl) {
    searchbarEl.addEventListener("keyup", function () {
      var value = this.value.toLowerCase();
      document.querySelectorAll("#collection-list li").forEach(function (li) {
        var link = li.querySelector(".product_flexi_title");
        li.style.display = (link && link.textContent.toLowerCase().includes(value)) ? "" : "none";
      });
    });
  }
  // Clear search on pressing clear button
  document.querySelectorAll(".search-clear").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      var searchbar = document.getElementById("searchbar");
      if (!searchbar) return;
      searchbar.value = "";
      // Trigger keyup event
      var event = new KeyboardEvent('keyup', { bubbles: true });
      searchbar.dispatchEvent(event);
    });
  });
});

    //Gokwik Code To Fetch
    window.addEventListener('DOMContentLoaded', (event) => {
      const submitBtnEl = document.getElementById('submit-btn');
      if (!submitBtnEl) return;
      submitBtnEl.addEventListener('click', (event) => {
        event.preventDefault();
        const flexiBoxForm = document.getElementById('flexi-box-form');
        const checkedInputs = flexiBoxForm.querySelectorAll('input:checked');
        const variantId = parseInt(flexiBoxForm.dataset.variantId);
        const parent_sku = flexiBoxForm.dataset.sku;
        const parent_price = parseFloat(flexiBoxForm.dataset.price / 100);

        let itemCounter = 1;
        let bundleCounter = 1;
        let total_regular_price = 0;
        let priceMarkUp = 0;

        const itemProperties = {};
        const bundleProperties = {};

        bundleProperties['_bundle_product1'] = `${parent_sku}/0/1`;
        bundleCounter++;

        // Safe rounding function
        function safeRound(num) {
          return Number(num.toFixed(2));
        }

        checkedInputs.forEach(function (input) {
          total_regular_price += parseInt(input.dataset.price);
        });

        checkedInputs.forEach(function (input, index) {
          if (input.value === 'No') {
            input.disabled = true;
          } else {
            itemProperties[`_ITEM${itemCounter}`] = input.value;

            // Proportional price safely rounded
            let proportional_price = safeRound((parseInt(input.dataset.price) / total_regular_price) * parent_price);

            priceMarkUp = safeRound(priceMarkUp + proportional_price);

            let lastDigit = safeRound(parent_price - priceMarkUp);
            let isLast = index === checkedInputs.length - 1;

            let finalPrice = isLast ? safeRound(proportional_price + lastDigit) : proportional_price;

            bundleProperties[`_bundle_product${bundleCounter}`] = `${input.dataset.sku}/${finalPrice}/1`;

            itemCounter++;
            bundleCounter++;
          }
        });

        let properties = {
          ...itemProperties,
          ...bundleProperties,
        };
        onBuyNowClick(event, false, [
          {
            id: variantId,
            quantity: 1,
            properties: properties,
          },
        ]);
      });
    });

  // Add / Remove button handlers for new card design
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.sc-new-add-btn, .sc-new-remove-btn');
    if (!btn) return;
    e.stopPropagation();
    var checkbox = document.getElementById(btn.getAttribute('data-checkbox-id'));
    if (checkbox && !checkbox.disabled) checkbox.click();
  });
  